import { api } from '../../services/api.js';
import { sessionChannel, notify } from '../../stores/index.js';

export const AuthLogic = (Base) => class extends Base {
    onMount() {
        super.onMount();
        this.root.addEventListener('form:submit', this.#handleLogin.bind(this));
        this.root.addEventListener('form:resend', this.#handleResend.bind(this));
        this.root.addEventListener('view:change', (e) => { this.view = e.detail.view; });

        // Verificar token si existe en la URL
        const params = new URLSearchParams(window.location.search);
        const verifyToken = params.get('verify');
        
        if (verifyToken) {
            this.#handleVerify(verifyToken);
        } else {
            this.view = 'login';
        }
    }

    async #handleVerify(token) {
        this.view = 'verifying';
        try {
            const response = await api.request(`/api/v1/registration/verify/${token}`, {
                method: 'GET'
            });

            if (response.token) {
                sessionStorage.setItem('authToken', response.token);
                sessionChannel.send({
                    token: response.token,
                    isAuthenticated: true
                });
                notify('Cuenta verificada con éxito', 'success');
            } else {
                 console.error('Token no recibido');
            }
        } catch (error) {
            console.error('[Verification Failed]', error);
            this.view = 'resend-verification';
            notify('El enlace ha expirado o no es válido', 'error');
        }
    }

    async #handleResend(e) {
        const { action, method, data } = e.detail;
        
        // Buscamos cuál de los dos formularios emitió el evento
        const form = this.root.querySelector('resend-verification-form') || this.root.querySelector('login-form');
        if (form) form.loading = true;

        try {
            const response = await api.request(action, {
                method: method,
                body: JSON.stringify(data)
            });

            notify(response.message || 'Verificación enviada', 'success');
            this.view = 'login';
        } catch (error) {
            notify(error.message, 'error');
        } finally {
            if (form) form.loading = false;
        }
    }

    async #handleLogin(e) {
        const { action, method, data } = e.detail;
        const form = this.root.querySelector('login-form');
        
        if (form) form.loading = true;

        try {
            const response = await api.request(action, {
                method: method,
                body: JSON.stringify(data)
            });

            if (response.token) {
                if (data.rememberMe) {
                    localStorage.setItem('authToken', response.token);
                } else {
                    sessionStorage.setItem('authToken', response.token);
                }

                sessionChannel.send({
                    token: response.token,
                    isAuthenticated: true
                });
                
                notify('Login exitoso', 'success');
            } else {
                console.error('Respuesta de servidor incompleta');
            }

        } catch (error) {
            notify(error.message, 'error');
            console.error('[Login Failed]', error);
        } finally {
            if (form) form.loading = false;
        }
    }
};
